import ReactTable from 'react-table';
import 'react-table/react-table.css';

import { PropTypes } from 'prop-types';

const ApplicationTable = ({ applicationList, pageSize, onRowClick }) => {

  const columns = [
    {
      Header: 'Project Name',
      accessor: "request_name",
    },
    {
      Header: 'Last updated by',
      accessor: "last_updated_by"
    },
    {
      Header: 'Last modification time',
      id: 'updatedcol',
      accessor: date => {
        try {
          return new Date(date.updated_time).toISOString();
        } catch (error) {
          // just swallow the error to render the table 
        }
      }
    },
    {
      Header: 'Status',
      accessor: "status"
    }
  ];

  const handleRowProps = (state, rowInfo) => ({
    onClick: () => {
        if (onRowClick !== undefined) {
          onRowClick(rowInfo.original)
        }
    },
    style: {
      color: (rowInfo && rowInfo.row.type === 'warning') ? 'red' : 'black',
      cursor: (rowInfo) ? 'pointer' : 'auto',
    },
  })

  return (
    <ReactTable
      className=" -striped -highlight"
      data={applicationList}
      columns={columns}
      defaultPageSize={pageSize}
      getTrProps={handleRowProps}
    />);
};

ApplicationTable.propTypes = {
  /**
   * Optional the list of application instances to display in the table.
   */
  applicationList: PropTypes.array,
  /**
   * Optional the number of rows to display per page.
   */
  pageSize: PropTypes.number,
  /**
   * Optional click handler for a row, will pass the original applicaiton object as a parameter.
   */
  onRowClick: PropTypes.func,
};

ApplicationTable.defaultProps = {
  applicationList:[],
  pageSize: 6,
  onRowClick: undefined,
};

export default ApplicationTable;